// modules/DoubleShortAnswerField.jsx
import React from "react";
import { Box, Typography, Grid, TextField } from "@mui/material";

const DoubleShortAnswerField = ({
  module,
  value,
  isEditable,
  onChange,
  fieldKey,
}) => {
  // We assume value is an object with an "answers" array.
  const answers = value && value.answers ? value.answers : ["", ""];

  const handleAnswerChange = (index, newValue) => {
    const newAnswers = [...answers];
    newAnswers[index] = newValue;
    // We pass the updated answers array wrapped in an object.
    onChange(fieldKey, { answers: newAnswers });
  };

  return (
    <Box marginY={2}>
      <Typography variant="h6">{module.label}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label={module.answer1Label || "Answer 1"}
            value={answers[0]}
            onChange={(e) => handleAnswerChange(0, e.target.value)}
            fullWidth
            required={module.required}
            margin="normal"
            InputProps={{ readOnly: !isEditable }}
            disabled={!isEditable}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={module.answer2Label || "Answer 2"}
            value={answers[1]}
            onChange={(e) => handleAnswerChange(1, e.target.value)}
            fullWidth
            required={module.required}
            margin="normal"
            InputProps={{ readOnly: !isEditable }}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DoubleShortAnswerField;
